import React, { SyntheticEvent } from "react";

interface LetterButtonProps {
  letter?: string;
  handleLetterPressed: Function;
  color?: string;
  isDisabled?: boolean;
}
export const LetterButton = ({
  letter,
  color,
  isDisabled,
  handleLetterPressed,
}: LetterButtonProps) => {
  const handleOnClick = (e: SyntheticEvent) => {
    const target = e.target as HTMLInputElement;
    handleLetterPressed(target.innerText);
  };

  const colorClasses = {
    light: "bg-gray-200 hover:bg-gray-300 text-gray-800",
    success: "bg-green-500 hover:bg-green-600 text-white",
    danger: "bg-red-500 hover:bg-red-600 text-white",
    primary: "bg-blue-500 hover:bg-blue-600 text-white",
  };

  const className = colorClasses[color as keyof typeof colorClasses] || colorClasses.light;

  return (
    <button
      disabled={isDisabled}
      onClick={handleOnClick}
      className={`px-4 py-2 m-1 rounded ${className} disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      {letter}
    </button>
  );
};
